import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container'];
  static values = { url: String };

  connect() {
    this.loaded = false;
  }

  load() {
    if (this.loaded) return;

    fetch(this.urlValue)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(json => {
        this.containerTarget.style.overflow = 'hidden';
        this.containerTarget.innerHTML = json.html;
        this.containerTarget.style.overflow = 'auto';
        this.loaded = true;
      })
      .catch(error => {
        this.containerTarget.innerHTML = '<p class="u-text-warning pam">Laden mislukt. Probeer het opnieuw.</p>';
        console.error('htmlloader fetch error:', error);
      });
  }
}

